export default function Bullet({current,items, setSliderPos}){
    return <div className="slider-bullet">
        {items.map((el,key) => {
            const classes = ['single-bullet'];
            if(key == current) classes.push('active')
            return <div className={classes.join(" ")} onClick={setSliderPos.bind(null,key)} key={key}></div>
        })}
    </div>
}